import {connect} from 'react-redux';
import {denormalize} from 'normalizr';

import {schema} from '../../../../../state/schema';
import {loadResourceServiceTags, deleteResourceServiceTag} from '../../../../../state/modules/resourceServiceTags/actions';
import {sendMessage} from '../../../../../state/actions';
import ResourceServiceTagsList from '../components/ResourceServiceTagsList';

const mapStateToProps = (state, ownProps) => {

  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.resourceServiceTags.getIn(['pages', order, limit, page]);

  return {
    list: result 
      ? result.map(x => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['resourceServiceTags', x]),
              schema.resourceServiceTag,
              state.entities.toJS()
            )
          };
        }).toArray()
      : [],
    isLoading: state.resourceServiceTags.get('isLoading'),
    total: state.resourceServiceTags.get('total'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadResourceServiceTags(page, limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deleteResourceServiceTag(id, cb));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const ResourceServiceTagsListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResourceServiceTagsList);

export default ResourceServiceTagsListContainer;
